module.exports = __webpack_public_path__ + "static/media/surface-7.55c36c1b.png";